module.exports = __webpack_public_path__ + "img/trivia.82a79857.svg";